import React from "react";
import i18n from "../lib/i18n";
import ModalDialog from "react-bootstrap/ModalDialog";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalTitle from "react-bootstrap/ModalTitle";
import ModalBody from "react-bootstrap/ModalBody";
import ModalFooter from "react-bootstrap/ModalFooter";

const Modal = ({
  title,
  children,
  buttons = null,
  onClose,
  includeDialog = true,
  closeLabel,
}) => {
  const modalContent = (
    <React.Fragment>
      <ModalHeader>
        <ModalTitle as="h4" id="myModalLabel">
          {title}
        </ModalTitle>
        <button type="button" className="close" onClick={onClose}>
          <span aria-hidden="true">×</span>
          <span className="sr-only">
            {closeLabel || i18n.t("js.components.modal.close")}
          </span>
        </button>
      </ModalHeader>
      <ModalBody>{children}</ModalBody>
      <ModalFooter>
        <button type="button" className="btn btn-secondary" onClick={onClose}>
          {closeLabel || i18n.t("js.components.modal.close")}
        </button>
        {buttons}
      </ModalFooter>
    </React.Fragment>
  );

  if (includeDialog) {
    return <ModalDialog>{modalContent}</ModalDialog>;
  }
  return modalContent;
};

export default Modal;
